import React from 'react';
import Devices from '../../components/tracking/Devices/Devices';
import Menu from '../../components/tracking/Menu/Menu';
import { useReload } from '../../hooks/use-reload';
import { Section } from '../../types/section';

export const PATH = `/${Section.TRACKING}`;

export default () => {
    const [reload, reloading] = useReload();

    return <div className="TrackingMainPage">
        <Menu reload={reload} />
        {reloading ?
            null :
            <Devices />}
    </div>;
};
